import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const TownLinks = () => {
  const [d, setD] = useState(null);
  const [p, setP] = useState("");
  useEffect(() => { api.get("/store/town-link-pattern").then((r) => { setD(r.data); setP(r.data.pattern); }).catch(() => {}); }, []);
  if (!d) return null;
  const save = async () => {
    try { const r = await api.put("/store/town-link-pattern", { pattern: p }); setD(r.data); setP(r.data.pattern); toast.success("Product page links saved for every town guide"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="border border-[#E2D9CC] bg-[#FAF7F2] p-5" data-testid="town-links">
      <p className="eyebrow mb-1 flex items-center gap-2"><Link2 className="w-4 h-4" />Town guide product pages</p>
      <p className="text-sm text-[#8C827A] mb-3">Where the free calculators' "Get the full guide" button and the shop feed point. Use {"{slug}"} for the town, e.g. gubbio.</p>
      <div className="flex flex-wrap gap-3 items-center">
        <Input value={p} onChange={(e) => setP(e.target.value)} className="rounded-none max-w-xl bg-white" data-testid="town-links-input" />
        <Button onClick={save} disabled={p === d.pattern} className="rounded-none" data-testid="town-links-save">Save</Button>
      </div>
      <p className="text-xs text-[#8C827A] mt-2" data-testid="town-links-example">Example: {d.example}</p>
    </div>
  );
};
